import gql from 'graphql-tag';

import { formElementFragment } from './getCaseDataForm';

export const UPDATE_CASE_DATA_FORM = gql`
  mutation ($appointmentId: String!, $input: [FormInput!]!) {
    updateCaseDataForm(
      appointmentId: $appointmentId,
      input: $input
    ) {
      form {
        ...FormElement_element
        elements {
          ...FormElement_element
        }
      }
    }
  }
  ${ formElementFragment }
`;
